import { ResCellContext, RowType, TableContentTransformations } from '../types';

export function generateTanstackCols<T extends Record<string, any>>(
  columns: Array<keyof T>,
  headingTranslations: Record<keyof T, string>,
  tableHeaderContentTransformations: TableContentTransformations<T>,
  tableBodyContentTransformations: TableContentTransformations<T>,
  sizes?: Partial<Record<keyof T, number>>,
) {
  return columns.map((col) => ({
    header:
      tableHeaderContentTransformations?.[col] || headingTranslations[col],

    accessorKey: col,
    cell: (info: ResCellContext<RowType, string>) =>
      tableBodyContentTransformations[col]?.(info.lead, info.config),
    ...(sizes ? { size: sizes?.[col] } : []),
  }));
}

export const isSortableCol = (
  key: string,
  sortingValues: Record<string, string>,
) => sortingValues && Object.keys(sortingValues).includes(key);

export const hasSettings = (
  key: string,
  onSettings: Record<string, () => void>,
) => onSettings && Object.keys(onSettings).includes(key);
